import React,
{
  useEffect, useRef, useState,
} from 'react';
import classNames from 'classnames';
import { INVALID_CLASS } from '../CreateAccount/hooks/useValidationHook';
import InputProps from '../CreateAccount/props/inputProps';
import styles from '../CreateAccount/scss/Input.module.scss';
import InputError from '../CreateAccount/InputError';
import { useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';

interface GetValidationClassProps { error: any, value: any, dirty: boolean }

const getValidationClass = (
  {
    error = null,
    value,
    dirty = false,
  }: GetValidationClassProps,
): string => {
  if (!dirty) return '';
  const isEmpty = value?.length === 0;
  if (!!error || isEmpty) {
    return INVALID_CLASS;
  }
  return '';
};

const ZipCodeInput: React.FunctionComponent<InputProps> = (props: InputProps) => {
  const [zipCode, setZipCode] = useState('');
  const [errorZipCodeClass, setErrorZipCodeClass] = useState('');
  const [dirty, setDirty] = useState(false);
  const {
    name,
    type,
    label,
    autoComplete,
    maxLength,
    placeholder,
    hasMargin,
    errorMessage,
    disabled,
    handleInput,
  } = props;
  const { previewError } = useSharedContext();

  useEffect(() => {
    const validationClass = getValidationClass({
      error: previewError,
      value: zipCode,
      dirty,
    });
    setErrorZipCodeClass(validationClass);
  }, [previewError, zipCode]);

  const inputRef = useRef(null);
  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setZipCode(value);
    setDirty(true);
  };

  const handleOnBlur = (
    e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (handleInput) handleInput(e);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleOnBlur(e);
  };

  return (
    <div className={classNames(styles.inputContainer,
      { [styles.inputContainerMargin]: hasMargin })}
    >
      <label htmlFor={name} className={styles.label}>
        {label}
        <input
          ref={inputRef}
          name={name}
          className={classNames(styles.input, errorZipCodeClass)}
          type={type}
          value={zipCode}
          onChange={handleZipCodeChange}
          onBlur={handleOnBlur}
          onKeyDown={handleOnKeyDown}
          placeholder={placeholder || label}
          autoComplete={autoComplete}
          maxLength={maxLength}
          disabled={disabled}
        />
        {errorZipCodeClass && <InputError errorMessage={errorMessage} />}
      </label>
    </div>
  );
};

ZipCodeInput.defaultProps = {
  disabled: false,
};

export default ZipCodeInput;
